import './../../../../core/assets/js/product'
import './../../../../core/assets/js/product_gallery'
import './../../../../core/assets/js/product_video';

$('#product-images').slider();